module.exports = __webpack_public_path__ + "img/quividiScrn1.38e41743.png";